import React, { useEffect } from 'react';
import { useLazyGetPackingListStatsCardQuery } from '../../../../services/Api';

function StatsCard({ title, value, icon: Icon, bgColor, isFirst }) {
 

    return (
        <div
            className={`${bgColor} p-6 rounded-2xl shadow-sm min-h-[200px] w-full grid grid-rows-[auto_auto_auto] items-center justify-items-center transition-all duration-300`}
        >
            <div
                className={`w-16 h-16 flex items-center justify-center mb-4 ${isFirst ? 'bg-white rounded-full' : 'bg-[#D9DCB0] rounded-full'
                    }`}
            >
                <img src={Icon} alt={title} className="w-10 h-10 object-contain" />
            </div>
            <span className="text-2xl font-bold mb-2">{value}</span>
            <p className="text-normalGray text-sm text-center">{title}</p>
        </div>
    );
}

export default StatsCard;
